module.exports = __webpack_public_path__ + "img/dirt-4.1484df3f.png";